var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';
import { space, width, borderColor } from 'styled-system';
var propTypes = __assign(__assign(__assign(__assign({}, space.propTypes), width.propTypes), borderColor.propTypes), { color: deprecatedColorValue() });
var Divider = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: ", ";\n  background-color: ", ";\n  ", "\n  ", " ", ";\n"], ["\n  border: 0;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: ", ";\n  background-color: ", ";\n  ", "\n  ", " ", ";\n"])), function (props) { return getPaletteColor(props.borderColor || props.color, 'base')(props); }, function (props) { return getPaletteColor(props.borderColor || props.color, 'base')(props); }, applyVariations('Divider'), space, width);
Divider.displayName = 'Divider';
Divider.defaultProps = {
    color: 'border',
    ml: 0,
    mr: 0,
};
Divider.propTypes = propTypes;
export default Divider;
var templateObject_1;
//# sourceMappingURL=Divider.js.map